import React, { useState, useEffect } from "react";
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import { FaPlus } from 'react-icons/fa';
import useDataHotels from '../../../../../dataHooks/useDataHotels'
import HotelCard from "./HotelCard";
import AddEditHotelModal from "./AddEditHotelModal";
import DeleteHotelModal from "./DeleteHotelModal";
import { checkHasEditEventPermissions, checkHasEventTrainerPermissions } from '../../../../../utils';

export default ({
  eventData = {}
}) => {
  const hasEditPermissions = ( checkHasEditEventPermissions() || checkHasEventTrainerPermissions() );

  const {
    isLoading,
    hotels,
    fetchHotels,
  } = useDataHotels()

  useEffect(() => {
    fetchHotels({ eventId : eventData.id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData.id])

  const [addEditHotelObj, setAddEditHotelObj] = useState(undefined)
  const [deleteHotelObj, setDeleteHotelObj] = useState(undefined)

  const onAddNewHotel = () => {
    setAddEditHotelObj({})
  }

  const onEditHotel = (hotelData) => {
    setAddEditHotelObj(hotelData)
  }

  const onAddEditHotelSuccess = () => {
    setAddEditHotelObj(undefined)
    fetchHotels({ eventId : eventData.id })
  }

  const onDeleteHotel = (hotelData) => {
    setDeleteHotelObj(hotelData)
  }

  const onDeleteHotelSuccess = () => {
    setDeleteHotelObj(undefined)
    fetchHotels({ eventId : eventData.id })
  }

  return (
    <div
      style={{
        padding: '20px'
      }}
    >
      {
        Boolean(addEditHotelObj) &&
        <AddEditHotelModal 
          hotel={addEditHotelObj}
          eventId={eventData.id}
          onClose={() => setAddEditHotelObj(undefined)}
          onSuccess={onAddEditHotelSuccess}
        />
      }
      {
        Boolean(deleteHotelObj) &&
        <DeleteHotelModal 
          hotel={deleteHotelObj}
          onClose={() => setDeleteHotelObj(undefined)}
          onSuccess={onDeleteHotelSuccess}
        />
      }
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          flex: 1,
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          marginLeft: '20px'
        }}>
          {'Lodging Reservations'}
        </div>
        {
          hasEditPermissions &&
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={onAddNewHotel}
          >
            <FaPlus style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Add Lodging'}</span>
          </Button>
        }
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            columnGap: '20px',
            rowGap: '20px',
            padding: '20px',
            flexWrap: 'wrap'
          }}>
            {hotels.length > 0
              ?
              hotels.map(hotel => {
                return <HotelCard key={hotel._id} hotelData={hotel} onEditHotel={onEditHotel} onDeleteHotel={onDeleteHotel} />
              })
              :
              <div>No lodging reservations have been added</div>
            }
          </div>
      }
    </div>
  )
}